import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { Differentials } from "@/components/site/Differentials";
import { About } from "@/components/site/About";
import { Treatments } from "@/components/site/Treatments";
import { Gallery } from "@/components/site/Gallery";
import { Testimonials } from "@/components/site/Testimonials";
import { EndoDelivery } from "@/components/site/EndoDelivery";
import { Faq } from "@/components/site/Faq";
import { Location } from "@/components/site/Location";
import { FinalCta } from "@/components/site/FinalCta";
import { Footer } from "@/components/site/Footer";
import { FloatingWhatsApp } from "@/components/site/FloatingWhatsApp";

function App() {
    useEffect(() => {
        const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
        let rafId;
        const loop = (time) => {
            lenis.raf(time);
            rafId = requestAnimationFrame(loop);
        };
        rafId = requestAnimationFrame(loop);

        const onClick = (e) => {
            const anchor = e.target.closest('a[href^="#"]');
            if (!anchor) return;
            const hash = anchor.getAttribute("href");
            if (!hash || hash.length < 2) return;
            const target = document.querySelector(hash);
            if (target) {
                e.preventDefault();
                lenis.scrollTo(target, { offset: -84 });
            }
        };
        document.addEventListener("click", onClick);

        return () => {
            cancelAnimationFrame(rafId);
            lenis.destroy();
            document.removeEventListener("click", onClick);
        };
    }, []);

    return (
        <div className="min-h-screen bg-[#FAFCFF] font-body text-slate-600 antialiased">
            <Header />
            <main>
                <Hero />
                <Marquee />
                <Differentials />
                <About />
                <Treatments />
                <Gallery />
                <Testimonials />
                <EndoDelivery />
                <Faq />
                <Location />
                <FinalCta />
            </main>
            <Footer />
            <FloatingWhatsApp />
        </div>
    );
}

export default App;
